
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RunGraphQL"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RunNode"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allTagsJson"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"apiId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"archiveRecord"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purpose"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"origin"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"admin"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"appendable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"archivable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"readable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unarchivable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"writable"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"schema"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"tagsJson"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"connection"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"shouldRecordEquipment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"equipment"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"studyIds"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"analysisIds"},"arguments":[],"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"HasCreatorGraphQL"},"directives":[]}]}}],"loc":{"start":0,"end":400}};
    doc.loc.source = {"body":"fragment RunGraphQL on RunNode {\n  allTagsJson\n  apiId\n  archiveRecord {\n    purpose\n  }\n  createdAt\n  id\n  origin {\n    type\n  }\n  permissions {\n    admin\n    appendable\n    archivable\n    readable\n    unarchivable\n    writable\n  }\n  schema {\n    id\n    name\n  }\n  tagsJson\n  connection {\n    id\n  }\n  shouldRecordEquipment\n  equipment {\n    id\n  }\n  studyIds\n  analysisIds\n  ...HasCreatorGraphQL\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["RunGraphQL"] = oneQuery(doc, "RunGraphQL");
        
